'use client';

import { useQuery } from '@tanstack/react-query';
import type { HTTPError } from 'ky';

import { getUrlToBackendApi, request } from '@/shared/modules/api';
import { getIsServerEnv } from '@/shared/modules/environment';

import { PUBLIC_PROFILE_DATA_QUERY_KEY, PUBLIC_REQUEST_PATHNAME } from '../constants';
import type { ProfilePublicData } from '../types';

import { useGetUserIdFromParams } from './use-get-user-id-from-params';
import { useIsMyProfile } from './use-is-my-profile';

export const usePublicProfileDataQuery = () => {
  const isMyProfile = useIsMyProfile();
  const currentUserId = useGetUserIdFromParams();

  return useQuery<ProfilePublicData, HTTPError>({
    /**
     * @note
     * We don't want to make an extra request during SSR (because we don't want to pass sensitive auth token through
     * the props) because we already prefetched this request in the page `server component` using the sensitive data
     * directly and it's safe.
     */
    enabled: getIsServerEnv() === false && isMyProfile === false,
    staleTime: 1000 * 60,
    queryKey: PUBLIC_PROFILE_DATA_QUERY_KEY,
    queryFn: () => {
      return request.get(`${getUrlToBackendApi(PUBLIC_REQUEST_PATHNAME)}?userId=${currentUserId}`).json();
    },
  });
};
